import React from 'react'

const WebStrategy = () => {
  return (
    // <div>WebStrategy</div>

    <section className="py-20 bg-slate-50">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        
        {/* TEXTE STRATÉGIQUE (GAUCHE) */}
        <div className="order-2 lg:order-1">
          <h2 className="text-secondary font-bold tracking-widest uppercase text-sm mb-4">
            Maximieren Sie Ihr Potenzial
          </h2>
          <h3 className="text-4xl md:text-5xl font-extrabold text-primary leading-[1.1] md:leading-[1.05] tracking-tight">
            Warum professionelles <span className="text-secondary">Webdesign</span> Ihr Erfolgsschlüssel ist.
          </h3>
          
          <div className="mt-8 text-lg text-slate-600 leading-relaxed">
            <p>
              In einer digitalen Welt ist Ihre Website nicht nur eine Visitenkarte, sondern Ihr <strong>stärkster Verkäufer rund um die Uhr</strong>. Ein durchdachtes <strong>Webdesign</strong> sorgt nicht nur für einen bleibenden ersten Eindruck, sondern schafft das notwendige Vertrauen, um aus anonymen Besuchern loyale Kunden zu machen.
            </p>
            <p>
              Ohne eine strategische <strong>SEO Optimierung</strong> und eine erstklassige <strong>User Experience</strong> bleibt Ihr Unternehmen für potenzielle Kunden unsichtbar. Wir kombinieren <strong>kreative Exzellenz</strong> mit technischer Präzision in der <strong>Webentwicklung</strong>, um Plattformen zu schaffen, die nicht nur schön aussehen, sondern messbare Ergebnisse liefern.
            </p>
            <p className="font-semibold text-primary">
              Sind Sie bereit, Ihre Konkurrenz digital zu überholen?
            </p>
          </div>

          <div className="mt-10 flex flex-wrap gap-4">
            <div className="flex items-center space-x-2 bg-white p-3 rounded-lg shadow-sm border border-slate-100">
              <span className="text-green-500 font-bold">✓</span>
              <span className="text-sm font-medium">Conversion-Optimiert</span>
            </div>
            <div className="flex items-center space-x-2 bg-white p-3 rounded-lg shadow-sm border border-slate-100">
              <span className="text-green-500 font-bold">✓</span>
              <span className="text-sm font-medium">Mobile First Design</span>
            </div>
          </div>
        </div>

        {/* VISUEL (DROITE) */}
        <div className="order-1 lg:order-2 relative w-full lg:h-[700px] group overflow-hidden rounded-3xl z-0">
          <img 
            src="/images/webdesign-agentur-performance.jpg" 
            alt="Strategische Webentwicklung und SEO Optimierung für Unternehmen" 
            className="rounded-3xl transition-transform duration-700 ease-in-out group-hover:scale-110 shadow-2xl z-10 relative w-full h-full object-cover"
          />
          

          {/* Overlay discret qui s'active au survol pour améliorer le contraste */}
          <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-20 pointer-events-none"></div>

          {/* Élément décoratif en arrière-plan */}
          <div className="absolute -bottom-6 -right-6 w-full h-full bg-secondary/10 rounded-3xl -z-10 transition-transform duration-500 group-hover:translate-x-2 group-hover:translate-y-2"></div>
        </div>

      </div>
    </section>
  )
}

export default WebStrategy